import 'es5-shim';
import 'es6-shim';
import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App/App'
import { unregister } from './registerServiceWorker';
import './index.css'

// import blueprint CSS
require("@blueprintjs/core/lib/css/blueprint.css");
require("@blueprintjs/icons/lib/css/blueprint-icons.css");

// monkey patch console log for production
const hostname = window && window.location && window.location.hostname;
if (hostname.indexOf('localhost') === -1) {
    console.log = () => { };
}

// Store first page time
let sessionTime = sessionStorage.getItem('session-time');
if (!sessionTime) {
    console.log("No session-time exists - setting new one.");
    sessionTime = Date.now();
    sessionStorage.setItem('session-time', sessionTime);
    console.log("Set session-time", sessionTime);
} else {
    console.log("Using existing session-time", sessionTime);
}

ReactDOM.render(<App />, document.getElementById('root'));

unregister();


// WEBPACK FOOTER //
// ./src/index.js